import { render, staticRenderFns } from "./core.html?vue&type=template&id=31162da4&scoped=true&"
import script from "./core.js?vue&type=script&lang=js&"
export * from "./core.js?vue&type=script&lang=js&"
import style0 from "./core.scss?vue&type=style&index=0&id=31162da4&prod&scoped=true&lang=scss&"
import style1 from "./index.vue?vue&type=style&index=1&id=31162da4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31162da4",
  null
  
)

export default component.exports